export const UNKNOWN_PATIENT = 'Unknown Patient'

export const DEFAULT_MARGIN_TOP = 94
